import { OptionTypes } from '../../../models/itinerary';
import { ActionTypes } from '../../constants/action-types';
import { SelectRateAction } from './types';

export function selectRate(rate: OptionTypes): SelectRateAction {
  return {
    type: ActionTypes.RATE_SELECT,
    rate,
  };
}
